import { css, useTheme } from '@emotion/react';
import { type MemoExoticComponent, memo, type ReactNode } from 'react';

import { CheckboxGroupCheckbox } from './checkbox/Checkbox';
import {
  CheckboxGroupContextProvider,
  type CheckboxGroupContextProviderProps,
} from './contexts/CheckboxGroup.context';

export type CheckboxGroupProps = CheckboxGroupContextProviderProps & {
  /** Add className to override default style. */
  className?: string;
  /** Content. */
  children?: ReactNode;
};

export const CheckboxGroupBase = ({
  className = null,
  children = null,
  ...props
}: CheckboxGroupProps) => {
  const theme = useTheme();

  return (
    <div
      className={className}
      css={css`
        display: flex;
        flex-wrap: wrap;
        gap: 10px;

        padding: 14px;

        border: 1px solid ${theme.colors.gray[50]};
        border-radius: 4px;
      `}
    >
      <CheckboxGroupContextProvider {...props}>{children}</CheckboxGroupContextProvider>
    </div>
  );
};

CheckboxGroupBase.displayName = 'CheckboxGroup';

export const CheckboxGroup: MemoExoticComponent<typeof CheckboxGroupBase> & {
  Checkbox?: typeof CheckboxGroupCheckbox;
} = memo(CheckboxGroupBase);

CheckboxGroup.Checkbox = CheckboxGroupCheckbox;
